module.exports = __webpack_public_path__ + "static/media/team-ribbon-front.7688db02.png";